/* eslint-disable react-hooks/exhaustive-deps */
import React from "react";

const GoogleContactUs = () => {

    return (
        <>
            <div className="main-wrapper landing-page-order-screens">
                <div className={`cards-wrap card-success`}>
                    <div className="card-body landing-page-order-model">
                        <div className="header w-100">
                            <p className="title-medium w-100 text-center">
                                <img src="Assets/Images/Logos/kiddo_blue_logo.png" alt="Kiddo Health" />
                            </p>
                        </div>
                        <iframe src="https://docs.google.com/forms/d/e/1FAIpQLSe0JhXv2GzxhSnWUJaZZgpTMu7Z-u4tO_5kaKqLCoyelL0LYA/viewform?embedded=true" width={"100%"} height="1300" title="Loading...">Loading…</iframe>
                        {/* <div className="card-inner confirm-order">
                                    <div className="address-details-form">
                                        <form className="" noValidate onSubmit={(e) => {
                                            e.preventDefault();
                                            formik.handleSubmit();
                                            return false;
                                        }}>
                                            <>
                                                <div className="row">
                                                    <div className="col-lg-6">
                                                        <div className="form-group">
                                                        {isLoading ? (
                                                                <SkeletonLoading baseColor="#ececec" highlightColor="#6e6e6e" width={"100%"} height={41} />
                                                            ) : (
                                                                <Input
                                                                    name="firstname"
                                                                    label="First name"
                                                                    inputValue={formik.values.firstname}
                                                                    onBlur={formik.handleBlur}
                                                                    onChange={formik.handleChange}
                                                                    onKeyDown={() => formik.setTouched({ ...formik.touched, firstname: true })}
                                                                    type="text"
                                                                    isError={formik.errors.firstname && formik.touched.firstname ? true : false}
                                                                    errorMessage={formik.errors.firstname && formik.touched.firstname ? formik.errors.firstname : undefined} />
                                                            )
                                                        }
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-6">
                                                        <div className="form-group">
                                                        {isLoading ? (
                                                                <SkeletonLoading baseColor="#ececec" highlightColor="#6e6e6e" width={"100%"} height={41} />
                                                            ) : (
                                                                <Input
                                                                    name="surname"
                                                                    label="Last name"
                                                                    inputValue={formik.values.surname}
                                                                    onBlur={formik.handleBlur}
                                                                    onChange={formik.handleChange}
                                                                    onKeyDown={() => formik.setTouched({ ...formik.touched, surname: true })}
                                                                    type="text"
                                                                    isError={formik.errors.surname && formik.touched.surname ? true : false}
                                                                    errorMessage={formik.errors.surname && formik.touched.surname ? formik.errors.surname : undefined} />
                                                            )
                                                        }
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="row">
                                                    <div className="col-lg-6">
                                                        <div className="form-group">
                                                            {isLoading ? (
                                                                    <SkeletonLoading baseColor="#ececec" highlightColor="#6e6e6e" width={"100%"} height={41} />
                                                                ) : (
                                                                    <Input
                                                                        name="email"
                                                                        label="Email address"
                                                                        inputValue={formik.values.email}
                                                                        onBlur={formik.handleBlur}
                                                                        onChange={formik.handleChange}
                                                                        onKeyDown={() => formik.setTouched({ ...formik.touched, email: true })}
                                                                        type="email"
                                                                        isError={formik.errors.email && formik.touched.email ? true : false}
                                                                        errorMessage={formik.errors.email && formik.touched.email ? formik.errors.email : undefined} />
                                                                )
                                                            }
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-6">
                                                        <div className="form-group">
                                                            {isLoading ? (
                                                                <SkeletonLoading baseColor="#ececec" highlightColor="#6e6e6e" width={"100%"} height={41} />
                                                            ) : (
                                                                    <Input
                                                                        name="ecMobile"
                                                                        id="ecMobile"
                                                                        label="Phone number"
                                                                        inputValue={formik.values.ecMobile}
                                                                        onBlur={(e: FocusEvent<HTMLInputElement>) => onMobileNumberInputBlur(e.target.value)}
                                                                        onChange={(e: ChangeEvent<HTMLInputElement>) => onMobileNumberChange(e.target.value)}
                                                                        onKeyDown={() => formik.setTouched({ ...formik.touched, ecMobile: true })}
                                                                        type="tel"
                                                                        isError={formik.errors.ecMobile && formik.touched.ecMobile ? true : false}
                                                                        errorMessage={formik.errors.ecMobile && formik.touched.ecMobile ? formik.errors.ecMobile : undefined} />
                                                            )
                                                            }
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="row">                                                           
                                                    <div className="col-lg-12">
                                                        <div className="form-group">
                                                        {isLoading ? (
                                                                <SkeletonLoading baseColor="#ececec" highlightColor="#6e6e6e" width={"100%"} height={41} />
                                                            ) : (
                                                                <Textarea
                                                                    name="message"
                                                                    label="Message"
                                                                    inputValue={formik.values.message}
                                                                    onBlur={formik.handleBlur}
                                                                    onChange={formik.handleChange}
                                                                    onKeyDown={() => formik.setTouched({ ...formik.touched, message: true })}
                                                                    type="textarea"
                                                                    isError={formik.errors.message && formik.touched.message ? true : false}
                                                                    errorMessage={formik.errors.message && formik.touched.message ? formik.errors.message : undefined}
                                                                    rows={4} />
                                                            )
                                                        }
                                                        </div>
                                                    </div>
                                                </div>
                                            </>
                                            {isLoading ? (
                                                <>
                                                    <div className="btn-wrap scal-btn">
                                                        <SkeletonLoading baseColor="#ececec" highlightColor="#6e6e6e" width={252} height={54} style={{
                                                            borderRadius: '50px'
                                                        }}/>
                                                    </div>
                                                </>
                                            ) : (
                                                <>
                                                    <Button
                                                        btntype="submit"
                                                        customClass={"btn-success order-btn-success"}
                                                        primary={true}
                                                        text={true}
                                                        label="Submit"
                                                        disabled={!formik.isValid}
                                                    />
                                                </>
                                            )}
                                        </form>
                                    </div>
                                </div> */}
                    </div>
                </div>
            </div>
        </>
    );
};

export default GoogleContactUs;